import React, { Fragment, useState, useEffect, useRef } from "react";
import { ReactComponent as CloseIcon } from "../../assets/x.svg";
import ErrorBanner from "../../components/ErrorBanner";
import StockLocationsController from "../../controllers/StockLocationsController";
import { useTranslation } from "react-i18next";
import SearchBar from "../../components/SearchBar";
import styles from "./ProductAssociation.module.css";
import { ProductAssociationHeadings } from "./ProductAssociationHeadings.js";
import ProductsList from "./ProductsList.js";
import EditProductAssociation from "./EditProductAssociation";
import ProductController from "../../controllers/ProductController";

const ProductAssociation = ({
  user,
  onClose,
  onCreated,
  site,
  nodeList,
  filteredNodeList,
  setNodeList,
  selectedStockLocation,
  onUpdated,
  currentAction,
  ADD_STOCK_LOCATION,
  EDIT_STOCK_LOCATION,
  DELETE_STOCK_LOCATION,
  ADD_CHILD,
  ADD_PRODUCT,
  EDIT_PRODUCT,
  parent,
  productAssociations,
  isSubmitting,
  setIsSubmitting,
  error,
  setError,
  errors,
  setErrors,
  name,
  setName,
  type,
  setType,
  isControlled,
  setIsControlled,
  barcode,
  setBarcode,
  orderPriority,
  setOrderPriority,
  active,
  setActive,
  device,
  setDevice,
  tabs,
  setTabs,
  selectedTab,
  setSelectedTab,
  APIndex,
  setAPIndex,
}) => {
  const { t, i18n } = useTranslation("productAssociations");
  const pcRef = useRef(null);

  useEffect(()=>{
    pcRef.current = new ProductController();
  }, [])

  const [filterText, setFilterText] = useState("");

  const [allowProductAddition, setAllowProductAddition] = useState(true);

  const handleSearch = (searchText) => {
    setFilterText(searchText.toUpperCase());
  };

  const _controller = useRef(null);

  const filteredProductAssociations = productAssociations.filter((product) => {
    if (
      filterText !== "" &&
      (product.packageId.toUpperCase().includes(filterText.toUpperCase()) ||
        pcRef.current.getDefaultName(product).toUpperCase().includes(filterText.toUpperCase()) ||
        product.manufacturer.fullName.toUpperCase().includes(filterText.toUpperCase()))
    ) {
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    _controller.current = new StockLocationsController(user, site);
  }, []);

  useEffect(() => {
    if (selectedStockLocation) {
      setName(selectedStockLocation.obj.name);
      setType(selectedStockLocation.obj.type);
      setBarcode(selectedStockLocation.obj.barcode);
      setIsControlled(selectedStockLocation.obj.isControlled);
      setOrderPriority(selectedStockLocation.obj.orderPriority);
      setActive(selectedStockLocation.obj.isEnabled);
      setDevice(selectedStockLocation.obj.device);
    }
  }, [selectedStockLocation]);

  const handleOnClose = () => {
    onClose();
  };

  const handleAllowProductAddition = () => {
    setAllowProductAddition(true);
  };

  const handleDenyProductAddition = () => {
    setAllowProductAddition(false);
  };

  const Backdrop = () => {
    return <div className={styles.backdrop} />;
  };

  const ModalOverlay = (props) => {
    return (
      <div className={styles.modal}>
        <div className={styles.content}>{props.children}</div>
      </div>
    );
  };

  const Modal = () => {
    return (
      <Fragment>
        <Backdrop />
        <ModalOverlay>
          <div className={styles.addAP__errorBannerContainer}>
            <ErrorBanner
              message={t("controlledProductError")}
              onClose={() => handleAllowProductAddition()}
            />
          </div>
        </ModalOverlay>
      </Fragment>
    );
  };

  if (currentAction === ADD_PRODUCT) {
    return (
      <section className={styles.addAP__container}>
        {!allowProductAddition ? (
          <Fragment>
            <Modal />
          </Fragment>
        ) : null}

        <section className={styles.addAP__header}>
          <p className={styles.addAP__title}>
            {t("addEquivalencyLabel") + " " + selectedStockLocation.obj.name}
          </p>
          <div
            className={styles.addAP__closeIconContainer}
            onClick={() => {
              handleOnClose();
            }}
          >
            <CloseIcon className={styles.addAP__closeIcon} />
          </div>
        </section>

        <div className={styles.addAP__searchBarContainer}>
          <SearchBar
            placeholder={t("searchPlaceholder")}
            onSearch={handleSearch}
          />
        </div>

        <div className={styles.addAP__productsHeadingsContainer}>
          <ProductAssociationHeadings />
        </div>

        <ProductsList
          user={user}
          site={site}
          filteredProductAssociations={filteredProductAssociations}
          selectedStockLocation={selectedStockLocation}
          nodeList={nodeList}
          setNodeList={setNodeList}
          setIsSubmitting={setIsSubmitting}
          setError={setError}
          onClose={onClose}
          onHandleAllowProductAddition={handleAllowProductAddition}
          onHandleDenyProductAddition={handleDenyProductAddition}
        />
      </section>
    );
  } else {
    return (
      <div>
        <EditProductAssociation
          user={user}
          site={site}
          nodeList={nodeList}
          setNodeList={setNodeList}
          filteredNodeList={filteredNodeList}
          selectedStockLocation={selectedStockLocation}
          onClose={onClose}
          onCreated={onCreated}
          onUpdated={onUpdated}
          currentAction={currentAction}
          ADD_STOCK_LOCATION={ADD_STOCK_LOCATION}
          EDIT_STOCK_LOCATION={EDIT_STOCK_LOCATION}
          DELETE_STOCK_LOCATION={DELETE_STOCK_LOCATION}
          ADD_CHILD={ADD_CHILD}
          EDIT_PRODUCT={EDIT_PRODUCT}
          parent={parent}
          productAssociations={productAssociations}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          error={error}
          setError={setError}
          errors={errors}
          setErrors={setErrors}
          name={name}
          setName={setName}
          type={type}
          setType={setType}
          isControlled={isControlled}
          setIsControlled={setIsControlled}
          barcode={barcode}
          setBarcode={setBarcode}
          orderPriority={orderPriority}
          setOrderPriority={setOrderPriority}
          active={active}
          setActive={setActive}
          device={device}
          setDevice={setDevice}
          tabs={tabs}
          setTabs={setTabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          APIndex={APIndex}
          setAPIndex={setAPIndex}
        />
      </div>
    );
  }
};

export default ProductAssociation;
